export default __webpack_public_path__ + "static/media/logo.959ef871.svg";